import {Box, FormControlLabel} from "@mui/material";

import {submitChangeMultiFactor} from "@/services/auth";
import {getCustomerVerificationSteps} from "@/services/customer";
import SwitchSimple from "@/components/Shared/SwitchSimple";
import {useNotificationContext} from "@/contexts/NotificationContext";
import {UICardContent, UICardHeadingLight} from "@/components/Shared/Utils/UICard";
import {useAuthContext} from "@/contexts/AuthContext.tsx";

export default function ManageMultiFactor({customer}: any) {
    const {notification, setNotification} = useNotificationContext();

    const {data: verification} = getCustomerVerificationSteps();
    const {user} = useAuthContext();

    async function handleUpdateMultiFactor(event: any) {
        let payload = verification?.mfa;

        if (event?.target?.checked) {
            payload = {
                mfa: true,
                mfa_method: 'email',
                mfa_information: customer?.customer_email || user?.email,
            }
        } else {
            payload = {
                mfa: false
            }
        }

        const response = await submitChangeMultiFactor({
            mfa: payload
        })

        // console.log(response)
        if (response?.data?.mfa !== null) {
            setNotification({...notification, message: `account mfa update success`, severity: 'success', open: true})
        }
    }

    return (
        <>
            <UICardHeadingLight title="Multi Factor Authentication"
                                description="For secure access, we'll send a verification code to your email each time you log in."/>
            <UICardContent>
                <Box p={2}>
                    <FormControlLabel
                        control={<SwitchSimple sx={{m: 1}} defaultChecked={verification?.mfa?.enable}/>}
                        label="Enable 2FA"
                        slotProps={{typography: {fontSize: 13}}}
                        onChange={handleUpdateMultiFactor}
                    />
                </Box>
            </UICardContent>
        </>
    )
}